import type { ApiResponse, InstructionPayload } from '@/store/types'
import { put } from '@/backend/api'
import type { ParsedError } from '@/backend/error'
import { errorMessages, isErrorResponse, parseError } from '@/backend/error'
import type { UUID } from '@/backend/schema/uuid'
import { decodeInstruction, type Instruction } from '@/backend/schema/instruction'

/**
 * Updates AI assisted review instruction on backend
 */
export const updateInstruction = async (params: {
  team_slug: string
  id: UUID
  title: string
}): Promise<ApiResponse<Instruction> | ParsedError> => {
  const { team_slug, id, ...rest } = params
  const path = `v2/teams/${team_slug}/ai_review/instructions/${id}`

  try {
    const response = await put<InstructionPayload>(path, rest)

    return {
      data: decodeInstruction(response.data),
    }
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }

    return parseError(error, errorMessages.INSTRUCTION_UPDATE)
  }
}
